import Vue from 'vue'
import Toaster from 'v-toaster'
import _ from 'lodash'

Vue.use(Toaster, {timeout: 10000});

export const EventBus = new Vue({});

EventBus.$on('serverError', argument => { 
    if(argument.error === undefined){
        return;
    }
    let status = argument.error.status;
    if(argument.component.$auth) {
        if ((status == 400 || status == 401) && !argument.component.$router.history.current.path.includes("/stby") && argument.component.$router.history.current.path != "/dashboard/ticket") {
            argument.component.$auth.logout().then(function () {
                argument.component.$router.push('/');
                Vue.prototype.$me = {
                    price: 0,
                    user: {
                        profile: {
                            name: ''
                        },
                        news: [],
                        unseenNews: []
                    },
                    id: -1
                };

            }).catch(function () {
                argument.component.$router.push('/');

                Vue.prototype.$me = {
                    price: 0,
                    user: {
                        profile: {
                            name: ''
                        },
                        news: [],
                        unseenNews: []
                    },
                    id: -1
                };

            });
        }
    }

    if(status == 422){
        let errors = argument.error.data.errors;
        let isObject = _.every(errors, _.isObject);
        _.forEach(errors, function (error) {

            if (isObject) {
                _.forEach(error, function (message) {
                    argument.component.$toast.error(message);
                });
            }
            else {
                argument.component.$toast.error(error);
            }
        });
    }
    else {
        if((status == 400 || status == 401)){
            //localStorage.removeItem(this.$auth.options.storageNamespace + '.' + this.$auth.options.tokenPrefix  + '_' + this.$auth.options.tokenName);
            if(!argument.component.$router.history.current.path.includes("/stby")) {
                argument.component.$toast.error(argument.error.data.message);
            }
        }else{
            argument.component.$toast.error(argument.error.data.message);
        }

    }
});


// WEBPACK FOOTER //
// ./src/services/EventBus.js